import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=bf5611ce&"
import script from "./MenuTree.vue?vue&type=script&lang=js&"
export * from "./MenuTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports